export const fontSizes = {
    'display.l': '5rem',
    'display.m': '4rem',
    'display.s': '5xl',
    'heading.xl': '2.5rem',
    'heading.l': '2rem',
    'heading.brand': '2xl',
    'heading.m': 'xl',
    'heading.s': 'lg',
    'heading.xs': 'md',
    'body.2xl': '2rem',
    'body.xl': 'md',
    'body.l': 'md',
    'body.m': 'sm',
    'body.s': 'sm',
    'body.xs': 'xs',
    'body.2xs': 'xs'
};
export const fontWeights = {
    'display.l': 'bold',
    'display.m': 'bold',
    'display.s': 'bold',
    'heading.xl': 'bold',
    'heading.l': 'bold',
    'heading.brand': 'bold',
    'heading.m': 'bold',
    'heading.s': 'bold',
    'heading.xs': 'medium',
    'body.2xl': 'black',
    'body.xl': 'bold',
    'body.l': 'normal',
    'body.m': 'semibold',
    'body.s': 'normal',
    'body.xs': 'semibold',
    'body.2xs': 'normal'
};
export const lineHeights = {
    'display.l': '5rem',
    'display.m': '4.5rem',
    'display.s': '3rem',
    'heading.xl': '2.5rem',
    'heading.l': '2rem',
    'heading.brand': '1.5rem',
    'heading.m': '1.5rem',
    'heading.s': '1.5rem',
    'heading.xs': '1.25rem',
    'body.2xl': '2.5rem',
    'body.xl': '1.5rem',
    'body.l': '1.5rem',
    'body.m': '1.25rem',
    'body.s': '1.25rem',
    'body.xs': '1rem',
    'body.2xs': '1rem'
};
export const fontFamilies = {
    'display.l': 'heading',
    'display.m': 'heading',
    'display.s': 'heading',
    'heading.xl': 'heading',
    'heading.l': 'heading',
    'heading.brand': 'heading',
    'heading.m': 'body',
    'heading.s': 'body',
    'heading.xs': 'body',
    'body.2xl': 'body',
    'body.xl': 'body',
    'body.l': 'body',
    'body.m': 'body',
    'body.s': 'body',
    'body.xs': 'body',
    'body.2xs': 'body'
};

//# sourceMappingURL=typography.js.map